import { shallowEqual } from 'react-redux';

import { ConversationCopilotDropdown } from 'components/conversation';
import { getLatestFacebookConversation } from 'components/conversation/selectors';
import { canClaimConversation } from 'components/conversation/utils/canClaimConversation';
import { canTakeOverConversation } from 'components/conversation/utils/canTakeOverConversation';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { ElevioResolveButton } from '../../integrations/elevio/src/components/ConversationResolution';

import { ConversationClaimButton } from './components/conversationClaimButton/conversationClaimButton';
import { ConversationCloseButton } from './components/conversationCloseButton/conversationCloseButton';
import { ConversationFollowUp } from './components/conversationFollowUp/conversationFollowUp';
import { ConversationResolveButton } from './components/conversationResolveButton/conversationResolveButton';
import styles from './conversationActionBar.module.scss';

export const ConversationActionBar = (): JSX.Element => {
  const { requester, conversation, isAssignedToMe, latestFacebookCsid } =
    useAppSelector(
      (state) => ({
        requester: state.conversation.metaConversation.requester,
        conversation: state.conversation.metaConversation.conversation,
        isAssignedToMe: state.conversation.metaConversation.isAssignedToMe,
        latestFacebookCsid: getLatestFacebookConversation(state),
      }),
      shallowEqual,
    );

  const canClaim =
    (!!requester?.anonymized_at &&
      canTakeOverConversation(conversation, isAssignedToMe)) ||
    canClaimConversation(conversation, isAssignedToMe, latestFacebookCsid);

  return (
    <div className={styles.root}>
      <ConversationCopilotDropdown />
      {/* ElevioResolveButton renders null if Elevio integration not set up */}
      <ElevioResolveButton />
      <ConversationFollowUp />
      {canClaim ? <ConversationClaimButton /> : <ConversationCloseButton />}
      <ConversationResolveButton />
    </div>
  );
};
